import { render, staticRenderFns } from "./BrNameChangeModal.vue?vue&type=template&id=6f76a0d0&"
import script from "./BrNameChangeModal.vue?vue&type=script&lang=js&"
export * from "./BrNameChangeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports